import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Converts plural category names to singular form for badge display
 * Examples: "Blood Tests" → "Blood Test", "Allergy Tests" → "Allergy Test"
 */
export function singularizeCategory(category: string): string {
  if (!category) return category;
  
  // Simple rule: if it ends with "s", remove it for badge display
  if (category.endsWith('s')) {
    return category.slice(0, -1);
  }
  
  return category;
}
